import { useTranslation } from 'react-i18next';
import { VideoCameraSlashIcon } from '@phosphor-icons/react';
import { I18nNamespace } from '@/lib/i18n-namespaces';

export function VideoGapState() {
    const { t } = useTranslation(I18nNamespace.VIDEO);

    return (
        <div className="flex items-center justify-center w-full h-full bg-black-100 absolute inset-0">
            <div className="text-center text-grey-300 px-8">
                <VideoCameraSlashIcon className="size-10 mx-auto mb-3 text-grey-400" />
                <p className="text-lg font-medium mb-1">
                    {t('streaming.messages.noRecordingAtTime')}
                </p>
                <p className="text-sm text-grey-400">
                    {t('streaming.messages.seekToRecordedSegment')}
                </p>
            </div>
        </div>
    );
}
